import React from "react";
import { setGlobal } from 'reactn';
import ReactDOM from "react-dom";
import App from "./components/App";
import registerServiceWorker from "./registerServiceWorker";

setGlobal({
  userCountry: null,
  locations: null,
  selectedLocation: null,
  selectedBottleImageUrl: null
});

window.DiageoPS = {
  init(params, node, callback) {
    if (callback) {
      this.callback = callback;
      ReactDOM.render(<App {...params} method="script" />, node);
    } else {
      ReactDOM.render(<App {...params} />, node);
    }
  }
};

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js